document.addEventListener('DOMContentLoaded', () => {
    const loading = document.querySelector('.p-loading');
    if (!loading) return;
  
    if (sessionStorage.getItem('hasVisited')) {
      // 2回目以降
      loading.classList.add('is-visited');
    } else {
      // 初回：フラグ保存＆アニメーション実行
      sessionStorage.setItem('hasVisited', 'true');
      loading.classList.add('is-loaded');
    }
  });